.header {
    position: relative;
    color: var(--ink);
    padding: 16px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    cursor: pointer;
}

.header.expanded {
    padding-bottom: 8px;
}

.body {
    padding: 0 16px 16px 48px;
}

.collapse {
    border: 0;
    background: transparent;
    align-self: start;
    margin-left: auto;
    cursor: pointer;
}

.line-height-24 {
    line-height: 24px;
}

.success {
    background-color: var(--lime-lighter);
}

.information {
    background-color: var(--blue-lighter);
}

.warning {
    background-color: var(--orange-lighter);
}

.error {
    background-color: var(--red-lighter);
}
